import { useState, useEffect } from 'react'


import Collection from '../Collection/Collection'

import {
    slugify,
    getProducts,
    isEven,
    getUniqueListBy,
} from '../../helpers/helpers'

const boostLiveUrl =
    'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&collection_scope='

const CollectionBlock = ({ collection }) => {
    // console.log('collection', collection)
    // console.log('collection in collection, collectionTitle', collection, collection.collectionTitle)

    const [data, setData] = useState()
    const [numProducts, setNumProducts] = useState(0)

    const collectionId = collection.collectionId
    const collectionSlug = collection.collectionSlug
    // const sized = collection.sized ? collection.sized : false
    let slicedProducts

    const url = boostLiveUrl + collectionId
    // console.log('url in CollectionBlock', url)

    const guideItem = collection.guideItem
    // const guideItemPosition = collection.guideItem.guideItemPosition
    const numItems = collection.numItems ? collection.numItems : 7

    useEffect(() => {
        fetch(url).then((res) =>
            res.json().then((productData) => {
                // console.log('productData', collection.collectionTitle, productData)
                let numberOfProducts = productData.total_product
                setNumProducts(numberOfProducts)
            })
        )
    }, [collectionId, url, collection.collectionTitle])

    let pages

    // calculate number of "pages" of data in collection
    if (numProducts) {
        pages = Math.ceil(numProducts / 70)
    }

    useEffect(() => {
        getProducts(pages, url).then((queriedData) => {
            if (queriedData && queriedData.length) {
                setData(queriedData.flat(1))
            }
        })

        return () => setData()
    }, [url, pages])

    if (data && data.length) {
        // console.log('data', data)
        let availableProducts = data.filter((p) => {
            return p.available
        })

        slicedProducts = availableProducts.slice(0, numItems)

        // console.log('slicedProducts', collection.collectionTitle, slicedProducts)

        let variants = []

        data.map((p) => {
            variants.push(p.variants)
            variants = variants.flat()
            return null
        })
    }

    function groupByKey(array, key) {
        return array.reduce((hash, obj) => {
            if (obj[key] === undefined) return hash
            return Object.assign(hash, {
                [obj[key]]: (hash[obj[key]] || []).concat(obj),
            })
        }, {})
    }

    // console.log('active on load', active, collection.collectionTitle)

    return (
        <div
            className={`collection-block-outer ${collectionSlug}`}
            data-collection-id={collection.collectionId}
            id={collectionSlug}
        >
            <div className="collection-block-inner">

                <div className="collection-block-heading">
                    <h2>{collection.collectionTitle}</h2>
                    <span className="header-line"></span>
                </div>
                {collection.collectionSlug === 'personalize-it' ? (
                    <p className="collection-subhead">Items with personalized embroidery must be placed by 12/10 for delivery by 12/24.</p>
                ) : null}

                <div className="products-outer">
                    <div className="products-inner">

                        {slicedProducts ? (
                            <Collection
                                collection={collection}
                                productData={data}
                                products={slicedProducts}
                                numItems={numItems}
                                guideItem={guideItem}
                            />
                        ) : (
                            <div>Loading...</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CollectionBlock
